module.exports = __webpack_public_path__ + "img/step2-8.3a17b98c.png";